import { connect } from 'react-redux'
import toJS from '../general/toJS'
import WebsiteMenu from '../../components/PageWebsiteSubpages/WebsiteMenu';
import mergePagesState from '../../functions/mergePagesState';
import getData from '../../functions/getData';
import { CLI_CURRENT_CINEMA_ID, PROGRAM_CINEMAS, ROUTES_DATA } from '../../constants/state';

const mapStateToProps = (state, ownProps) => ({
    menuItems: mergePagesState(state, 'menuItems', 'items'),
    menuItemsOrder: mergePagesState(state, 'menuItems', 'order'),
    pages: mergePagesState(state, ownProps.type, 'items'),
    pagesOrder: mergePagesState(state, ownProps.type, 'order'),
    cinemas: getData(state, PROGRAM_CINEMAS),
    currentCinemaId: getData(state, CLI_CURRENT_CINEMA_ID),
    routes: getData(state, ROUTES_DATA)
})

const WebsiteMenuContainer = ({menuItems, menuItemsOrder, pages, routes, pagesOrder, cinemas, currentCinemaId}) => (
<WebsiteMenu
        menuItems={menuItems}
        cinemas={cinemas}
        routes={routes}
        menuItemsOrder={menuItemsOrder}
        pages={pages}
        pagesOrder={pagesOrder}
        currentCinemaId={currentCinemaId}
    />
)

export default connect(mapStateToProps, null)(toJS(WebsiteMenuContainer))